import { __assign } from "tslib";
import { createBasePlugin } from 'wix-rich-content-common';
import { EXTERNAL_MENTION_TYPE } from './types';
import createMentionPlugin from 'draft-js-mention-plugin';
import s from './styles.scss';
function externalMentionPluginCreator(pluginConfig) {
    var externalMentionPluginInstance = createMentionPlugin(__assign({ entityMutability: 'IMMUTABLE', mentionPrefix: '@', theme: s }, pluginConfig));
    var MentionSuggestions = externalMentionPluginInstance.MentionSuggestions;
    return {
        extras: {
            MentionSuggestions: MentionSuggestions,
        },
        plugin: function (config) {
            var type = EXTERNAL_MENTION_TYPE;
            var decorator = config.decorator, helpers = config.helpers, theme = config.theme, isMobile = config.isMobile, t = config.t, anchorTarget = config.anchorTarget, relValue = config.relValue;
            return createBasePlugin({
                decorator: decorator,
                theme: theme,
                type: type,
                helpers: helpers,
                isMobile: isMobile,
                anchorTarget: anchorTarget,
                relValue: relValue,
                t: t,
            }, externalMentionPluginInstance);
        },
    };
}
export { externalMentionPluginCreator };
//# sourceMappingURL=createMentionPlugin.js.map